import React, { useState } from 'react';
import { ParticipationKPIs } from './ParticipationKPIs';
import { ParticipationCharts } from './ParticipationCharts';
import { AbsenteesTable } from './AbsenteesTable';
import { ParticipationDrilldownModal } from './ParticipationDrilldownModal';

export const ParticipationTab = ({ onViewReport }) => {
  const [activeDrilldown, setActiveDrilldown] = useState(null);

  const handleDrilldown = (filter) => {
    setActiveDrilldown(filter);
  };

  const handleCloseDrilldown = () => {
    setActiveDrilldown(null);
  };

  return (
    <section id="participation" className="section-content">
      {/* Section Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-gray-800" id="participation-section-title">
          Student Participation
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          Detailed participation metrics across grades and school sections
        </p>
      </div>

      {/* KPI Stats & Breakdown */}
      <ParticipationKPIs />

      {/* Charts Grid */}
      <ParticipationCharts onDrilldown={handleDrilldown} />

      {/* Absentees Table */}
      <AbsenteesTable onDrilldown={handleDrilldown} />

      {/* Drilldown Container */}
      {activeDrilldown && (
        <ParticipationDrilldownModal
          filter={activeDrilldown}
          onClose={handleCloseDrilldown}
          onViewReport={(student) => {
            onViewReport(student);
          }}
        />
      )}
    </section>
  );
};
export default ParticipationTab;
